export const RequestsWithoutAccesstoken = [
    'register',
    'login',
    '.js',
    'forgot-password',
]

export const DisableLoaderCalls = ['.js', 'notifications']
